import React from 'react';
import { VolumeSlider as VolumeSliderContainer, VolumeScrubber, VolumeLevel } from './styled';
export const VolumeSlider = ({ playerInstance, className, muted, volume, styles, }) => (React.createElement(VolumeSliderContainer, { style: styles.container, "data-test": "VolumeSlider", className: `VolumeSlider ${className}` },
    React.createElement(VolumeLevel, { style: styles.volumeLevel, "data-test": "VolumeLevel-slider", className: "VolumeLevel", volume: volume, muted: muted },
        React.createElement(VolumeScrubber, { style: styles.volumeScrubber, "data-test": "VolumeScrubber", className: "VolumeScrubber", playerInstance }))));
VolumeSlider.defaultProps = {
    className: '',
    styles: {
        container: null,
        volumeLevel: null,
        volumeScrubber: null,
    },
};
//# sourceMappingURL=index.js.map